<div class="fixed bottom-0 left-[240px] z-50 w-[calc(100vw-240px)] bg-neutral-200 h-8 px-3 flex items-center">
  <p class="text-[0.95rem] text-neutral-900 font-medium">{{ currentYear }} © ATOZ Tax Advisers</p>
</div>
